import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { eastProvidenceConfig } from "./data";

export default function EastProvidencePage() {
  return <CityPageTemplate config={eastProvidenceConfig} />;
}